import React from 'react';

import { IAvailableCandidate } from '@types';
import { isAgileEngineer, primaryStackOf } from '@utils';
import { PersonNameCell } from 'components/candidate/CandidatesList/components/PersonNameCell';
import { AgileEngineBenchStar } from './AgileEngineBenchStar';

export const AvailableCandidateNameCell: React.FC<{
  candidate: IAvailableCandidate;
  withRegion?: boolean;
}> = ({ candidate, withRegion }) => (
  <PersonNameCell
    name={candidate.name}
    country={candidate.country}
    mark={isAgileEngineer(candidate) && <AgileEngineBenchStar />}
    subtitle={[candidate.seniority, primaryStackOf(candidate)]
      .filter(Boolean)
      .join(' · ')}
    withRegion={withRegion}
  />
);
